<template>
  <!--
        作者：kmdshop
        时间：2019-10-25
        描述：组件-选择商品
    -->
  <el-dialog title="选择门店" :visible.sync="dialogVisible" :append-to-body="true" @close="dialogFormVisible" :close-on-click-modal="false" :close-on-press-escape="false" width="900px">
    <div class="common-seach-wrap">
      <el-form :inline="true" size="small" :model="formInline" class="demo-form-inline">
       
        <el-form-item label="门店名称">
          <el-input placeholder="请输入门店名称" v-model="formInline.search">
            <!--  <el-select v-model="formInline.status" slot="prepend" placeholder="请选择商品状态" style="width: 80px;">
              <el-option label="全部" value="-1"></el-option>
                <el-option v-for="(item,index) in status" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>-->
            <el-button slot="append" icon="el-icon-search" @click="getData">查询</el-button>
          </el-input>
        </el-form-item>
      </el-form>
    </div>

    <!--内容-->
    <div class="product-content">
    <div class="table-wrap">
      <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
        <el-table-column prop="store_id" label="门店ID" width="60"></el-table-column>
        <el-table-column label="Logo" width="60">
          <template slot-scope="scope">
            <img v-if="scope.row.logo" v-img-url="scope.row.logo.file_path" width="30px" height="30px" />
          </template>
        </el-table-column>
        <el-table-column prop="store_name" label="门店名称"></el-table-column>
        <el-table-column prop="shop_hours" label="营业时间"></el-table-column>
        <el-table-column prop="shopManager.user.nickName" label="店长"></el-table-column>
        <el-table-column prop="linkman" label="联系人"></el-table-column>
        <el-table-column prop="phone" label="联系电话" width="100"></el-table-column>
        <el-table-column prop="detail_address" label="门店地址" width="240"></el-table-column>
        <el-table-column prop="is_check" label="自提核销">
          <template slot-scope="scope">
            <span :class="{ green: scope.row.is_check.value == 1, gray: scope.row.is_check.value == 0 }">{{ scope.row.is_check.text }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="status" label="门店状态">
          <template slot-scope="scope">
            <span :class="{ green: scope.row.status.value == 1, gray: scope.row.status.value == 0 }">{{ scope.row.status.text }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="create_time" label="创建时间" width="140"></el-table-column>
        <el-table-column fixed="right" label="操作" width="90">
          <template slot-scope="scope">
              <el-button size="small" type="primary" @click="addClerk(scope.row.store_id,scope.row.store_name)" >选 择</el-button>
           
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!--分页-->
    <div class="pagination">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        background
        :current-page="curPage"
        :page-size="pageSize"
        layout="total, prev, pager, next, jumper"
        :total="totalDataNumber"
      ></el-pagination>
    </div>
  </div>

  </el-dialog>
</template>

<script>
import StoreApi from '@/api/store.js';
export default {
  data() {
    return {
         /*是否加载完成*/
      loading: true,
      /*列表数据*/
      tableData: [],
      /*一页多少条*/
      pageSize: 20,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      /*横向表单数据模型*/
      formInline: {
          search:""
      },
      /*是否打开添加弹窗*/
      open_add: false,
      /*是否打开编辑弹窗*/
      open_edit: false,
      /*当前编辑的对象*/
      userModel: {},
      store_id:"",//选择的门店ID
      store_name:"",//门店名称
    };
  },
  props:["store_open"],
  created() {
      this.dialogVisible = this.store_open
  /*获取列表*/
  this.getTableList();
},
  methods: {
      getData(){

          this.getTableList();
      },
      /*选择第几页*/
      handleCurrentChange(val) {
      let self = this;
      self.curPage = val;
      self.loading = true;
      self.getTableList();
      },

      /*每页多少条*/
      handleSizeChange(val) {
      this.curPage = 1;
      this.pageSize = val;
      this.getTableList();
      },

      /*获取列表*/
      getTableList() {
      let self = this;
      let Params = {};
      Params.page = self.curPage;
      Params.list_rows = self.pageSize;
      console.log("self.formInline.search",self.formInline.search)
      Params.store_name = self.formInline.search
      StoreApi.shoplist(Params, true)
          .then(data => {
          self.loading = false;
          self.tableData = data.data.list.data;
          self.totalDataNumber = data.data.list.total;
          })
          .catch(error => {});
      },
          //点击确定
  addClerk(store_id,store_name) {
    let self = this;
     self.type = 'success';
     self.store_id = store_id
     self.store_name = store_name
     self.dialogVisible = false;
     self.dialogFormVisible(false)
     console.log("走了吗")
  },
        /*关闭弹窗*/
    dialogFormVisible(e) {
      var self = this;
      if (e) {
        this.$emit('closeDialog', {
          type: 'success',
          openDialog: false,
          store_id:self.store_id,
          store_name:self.store_name
        });
      } else {
        this.$emit('closeDialog', {
          type: 'error',
          openDialog: false,
          store_id:self.store_id,
          store_name:self.store_name
        });
      }
    },
  }
};
</script>

<style>
 .no-list .el-checkbox{ display: none;}
</style>



// WEBPACK FOOTER //
// src/components/store/store.vue